import api from '../service/services.js'
import moment from 'moment'
import numeral from 'numeral'
import swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import 'vue-loading-overlay/dist/vue-loading.min.css'
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'report',
  data () {
    return {
      users: '',
      config: '',
      datestart: moment(new Date()).format('YYYY-MM-DD'),
      dateend: moment(new Date()).format('YYYY-MM-DD'),
      title: '',
      Listdata: [],
      SelectedData: [],
      total_price: 0,
      clock: '../static/img/time.png',
      isLoading: false,
      configData: [],
      screenHeight: window.innerHeight - 225,
      arrayReport: []
    }
  },
  components: {
    QrcodeVue
  },
  methods: {
    getData () {
      this.isLoading = true
      let obj = {
        date_start: this.datestart,
        date_end: this.dateend
      }
      api.AXreportdayExpert(
        this.$store.state.url,
        obj,
        result => {
          if (result.status === 1) {
            if (result.data.length > 0) {
              this.Listdata = result.data
              this.configData = result.config
              this.SelectedData = result.data
              console.log(this.SelectedData)
              this.calPrice()
            } else {
              swal.fire(
                'แจ้งเตือนระบบ',
                'ไม่มีข้อมูลการขาย',
                'warning'
              )
            }
          } else {
            swal.fire(
              'แจ้งเตือนระบบ',
              'รายงานที่เลือกไม่มีข้อมูล',
              'warning'
            )
          }
          this.isLoading = false
        },
        error => {
          this.isLoading = false
          alert(JSON.stringify(error))
        }
      )
    },
    calPrice () {
      this.total_price = 0
      this.SelectedData.forEach(val => {
        this.total_price += parseInt(val['bill_data']['price'])
      })
    },
    processBill () {
      var data = []
      var i = 0
      var first_bill = ''
      var lastNumber = 0
      this.SelectedData.forEach(val => {
        var bill_number = val['bill_data']['bill_number']
        const bn = bill_number.substring(bill_number.length - 4, 0)
        if (i < 1) {
          first_bill = bill_number.substring(10, bill_number.length)
          lastNumber = first_bill
        } else {
          var firstNumber = ''
          lastNumber = parseInt(lastNumber) + 1
          for (var s = 0; s < 4; s++) {
            if (s < 4 - String(lastNumber).length) {
              firstNumber += '0'
            } else {
              firstNumber += lastNumber
              s = 4
            }
          }
          var newBill = bn + firstNumber
          val['bill_data']['bill_number'] = newBill
        }
        i++
      })
      this.redata()
      // alert(JSON.stringify(this.SelectedData))
    },
    title_time (time) {
      if (
        Date.parse(this.fm_dateEN(time) + ' ' + this.fm_time(time)) <=
        Date.parse(this.fm_dateEN(time) + ' 12:30')
      ) {
        return 'HM'
      } else if (
        Date.parse(this.fm_dateEN(time) + ' ' + this.fm_time(time)) <
        Date.parse(this.fm_dateEN(time) + ' 17:00')
      ) {
        return 'FD'
      } else if (
        Date.parse(this.fm_dateEN(time) + ' ' + this.fm_time(time)) >=
        Date.parse(this.fm_dateEN(time) + ' 18:00')
      ) {
        return 'HA'
      } else {
        console.log(Date.parse(this.fm_dateEN(time) + ' 19:00'))
        return 'HM'
      }
    },
    exportReport () {
      this.processBill()
      this.$refs.report22.submit()
      window.print()
    },
    redata () {
      this.arrayReport = []
      this.SelectedData.forEach(val => {
        this.arrayReport.push(val['bill_data'])
      })
    },
    fm_number (int) {
      return numeral(int).format('0,0')
    },
    fm_date (str) {
      return moment(str).format('DD/MM/YYYY')
    },
    fm_dateEN (str) {
      return moment(str).format('YYYY-MM-DD')
    },
    fm_time (str) {
      moment.locale('th')
      return moment(str).format('LT')
    }
  },
  mounted () {
    this.users = JSON.parse(sessionStorage.getItem('users'))
    this.config = JSON.parse(sessionStorage.getItem('config'))
    this.getData()
  }
}



// WEBPACK FOOTER //
// ./src/js/npreport.js